import { GET_TPP_SETTINGS_SUCCESS, GET_EMAIL_TEMPLATES_SUCCESS } from 'Constants/settingConstants';

const defaultState = {};

export default function SettingReducer(state = defaultState, action) {
  switch (action.type) {
    case GET_TPP_SETTINGS_SUCCESS:
      return {
        ...state,
        ...action.data.settings,
      };
    case GET_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        emailTemplates: action.data.emailTemplates,
      };
    default:
      return state;
  }
}
